import { LinkButton } from '../ui/button/link-button'
import { ErrorView } from '../ui/error-view'

export function NotFoundError() {
  return (
    <ErrorView
      title="Page Not Found"
      description="Click “Back to Home” to get you back on track."
      button={
        <LinkButton to="/" className="w-full">
          Back to Home
        </LinkButton>
      }
    />
  )
}
